import React from 'react';
import type { AuditPayload, CompetitorRow } from '../types';

interface Props {
  payload: AuditPayload;
}

function photoUrl(ref: string, w = 400): string {
  return `/api/photo?ref=${encodeURIComponent(ref)}&w=${w}`;
}

const PhotoStrip: React.FC<{ photos?: string[]; emptyHint?: string }> = ({ photos, emptyHint }) => {
  const list = (photos || []).slice(0, 4);
  if (list.length === 0) {
    return <div className="text-[11px] text-slate-400 italic py-3">{emptyHint || '掲載写真なし'}</div>;
  }
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
      {list.map((ref, i) => (
        <div key={ref + i} className="aspect-[4/3] bg-slate-100 overflow-hidden">
          <img
            src={photoUrl(ref, 400)}
            alt=""
            loading="lazy"
            className="w-full h-full object-cover"
            onError={(e) => { (e.target as HTMLImageElement).style.opacity = '0.3'; }}
          />
        </div>
      ))}
    </div>
  );
};

const PhotoComparison: React.FC<Props> = ({ payload }) => {
  const otherCompetitors = payload.competitors.filter((c) => !c.is_self).slice(0, 3);
  const anyPhotos =
    (payload.photo_names && payload.photo_names.length > 0) ||
    otherCompetitors.some((c) => c.photo_names && c.photo_names.length > 0);
  if (!anyPhotos) return null;

  return (
    <div className="py-4 border-b border-slate-200">
      <div className="flex items-baseline justify-between mb-3 flex-wrap gap-2">
        <h3 className="text-[13px] font-semibold text-slate-900">写真クオリティ比較</h3>
        <span className="text-[11px] text-slate-500">同エリア上位3店舗と並列表示</span>
      </div>

      <div className="space-y-4">
        <div>
          <div className="flex items-baseline gap-2 mb-2">
            <span className="text-[10px] font-semibold px-1 py-0 bg-brand-500 text-white rounded">自店</span>
            <span className="text-[12px] font-semibold text-slate-900">{payload.store_title}</span>
            <span className="text-[11px] text-slate-500">マップ {payload.rank} 位 / 写真 {payload.photo_count} 枚</span>
          </div>
          <PhotoStrip photos={payload.photo_names} emptyHint="写真未登録（競合は複数枚を活用）" />
        </div>

        {otherCompetitors.map((c: CompetitorRow) => (
          <div key={c.title}>
            <div className="flex items-baseline gap-2 mb-2">
              <span className="text-[10px] font-semibold px-1 py-0 bg-slate-500 text-white rounded">競合</span>
              <span className="text-[11px] text-slate-500">マップ {c.rank} 位</span>
              <span className="text-[12px] font-semibold text-slate-900">{c.title}</span>
              <span className="text-[11px] text-slate-500">写真 {c.photo_count} 枚</span>
            </div>
            <PhotoStrip photos={c.photo_names} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default PhotoComparison;
